var BlogCover = require('./BlogCover');
var Blog = {
	init: function() {
		Blog.initStats();
		BlogCover.init();
		var field = document.getElementById('blog-body');
		if (!field || !window.tinymce) return;
		tinymce.init({
			target: field, height: 500, menubar: false, skin: false, content_css: '/rich-text.css?v1.1',
			plugins: 'lists link image', toolbar: 'undo redo | blocks | bold italic | bullist numlist blockquote | link image',
			block_formats: 'Абзац=p; Подзаголовок=h2; Малый подзаголовок=h3',
			valid_elements: 'p,br,h2,h3,strong/b,em/i,u,ul,ol,li,blockquote,a[href|rel],img[src|alt],figure,figcaption',
			paste_data_images: true, automatic_uploads: true, image_dimensions: false,
			images_file_types: 'jpg,jpeg,png,webp', block_unsupported_drop: true,
			images_upload_handler: Blog.uploadImage,
			relative_urls: false, remove_script_host: true, document_base_url: window.location.origin + '/',
			branding: false, promotion: false,
			setup: function(editor) {
				editor.on('change SetContent Undo Redo NodeChange', function() {
					var body = editor.getBody();
					if (!body) return;
					var sources = Array.from(body.querySelectorAll('img')).map(function(image) { return image.src; });
					Object.keys(Blog.uploads).forEach(function(uri) {
						var state = Blog.uploads[uri];
						if (!state.pending && sources.indexOf(uri) === -1) { state.row.remove(); delete Blog.uploads[uri]; }
					});
				});
				editor.on('blur', function() {
					if (!document.getElementById('blog-excerpt').value.trim()) Blog.excerpt(false);
				});
			}
		});
	},
	initStats: function() {
		var article = document.querySelector('[data-blog-post]');
		if (article) Blog.record(article, 'view').catch(function() {});
	},
	record: function(article, action) {
		var data = new FormData();
		data.append('id', article.dataset.blogPost); data.append('csrf', article.dataset.blogCsrf); data.append('action', action);
		return fetch('/ajax.php?mid=' + article.dataset.blogMid, {method: 'POST', body: data}).then(Blog.response).then(function(res) {
			if (!res.success) throw new Error(res.error || 'Не удалось сохранить действие');
			var views = article.querySelector('[data-blog-views]'), likes = article.querySelector('[data-blog-likes]');
			views.textContent = Math.max(Number(views.textContent) || 0, res.views);
			likes.textContent = Math.max(Number(likes.textContent) || 0, res.likes);
			var button = article.querySelector('.blog__like');
			var liked = res.liked || button.getAttribute('aria-pressed') === 'true';
			button.disabled = liked || !!button.dataset.liking; button.setAttribute('aria-pressed', liked ? 'true' : 'false');
			button.firstChild.textContent = liked ? '♥ Нравится · ' : '♡ Нравится · ';
			if (res.liked) button.title = 'Вам понравилась статья';
			return res;
		});
	},
	like: function(button) {
		if (button.disabled) return;
		button.disabled = true;
		button.dataset.liking = '1';
		var article = button.closest('[data-blog-post]');
		Blog.record(article, 'like').then(function() { delete button.dataset.liking; article.querySelector('.blog__stats-message').textContent = ''; }).catch(function(error) {
			delete button.dataset.liking;
			button.disabled = false; article.querySelector('.blog__stats-message').textContent = error.message;
		});
	},
	uploads: {},
	uploadImage: function(blobInfo, progress) {
		var uri = blobInfo.blobUri();
		if (Blog.uploads[uri] && Blog.uploads[uri].pending) return Blog.uploads[uri].pending;
		var previous = Blog.uploads[uri];
		if (previous && previous.row) previous.row.remove();
		var row = document.createElement('div');
		row.className = 'blog__upload';
		var spinner = document.createElement('span');
		spinner.className = 'blog__upload-spinner';
		spinner.setAttribute('aria-hidden', 'true');
		var label = document.createElement('span');
		label.textContent = 'Загружаем картинку…';
		row.appendChild(spinner); row.appendChild(label);
		document.getElementById('blog-uploads').appendChild(row);
		var state = {row: row}; Blog.uploads[uri] = state;
		state.pending = new Promise(function(resolve, reject) {
			var form = document.getElementById('blog-form');
			var container = form.closest('[data-blog-mid]');
			var xhr = new XMLHttpRequest();
			function fail(message) {
				delete state.pending;
				spinner.remove(); row.classList.add('blog__upload--error');
				label.textContent = message;
				var retry = document.createElement('button');
				retry.type = 'button'; retry.className = 'btn btn--secondary'; retry.textContent = 'Повторить';
				retry.onclick = function() { Blog.retryImages(); };
				row.appendChild(retry);
				reject(message);
			}
			if (blobInfo.blob().size > 5 * 1024 * 1024) {
				setTimeout(function() { fail('Картинка больше 5 МБ. Уменьшите её или удалите из текста.'); }, 0); return;
			}
			xhr.open('POST', '/ajax.php?mid=' + container.dataset.blogMid);
			xhr.timeout = 120000;
			xhr.upload.onprogress = function(event) {
				if (!event.lengthComputable) return;
				var percent = Math.round(event.loaded / event.total * 100);
				progress(Math.min(percent, 99));
				label.textContent = percent === 100 ? 'Конвертируем в WebP…' : 'Загружаем картинку: ' + percent + '%';
			};
			xhr.onload = function() {
				var result;
				try { result = JSON.parse(xhr.responseText); }
				catch (err) { fail('Сервер вернул некорректный ответ при загрузке картинки'); return; }
				if (xhr.status < 200 || xhr.status >= 300 || !result.success || typeof result.location !== 'string') {
					fail(result.error || 'Не удалось загрузить картинку'); return;
				}
				progress(100); row.remove(); delete Blog.uploads[uri]; resolve(result.location);
			};
			xhr.onerror = function() { fail('Не удалось загрузить картинку. Проверьте соединение.'); };
			xhr.ontimeout = function() { fail('Загрузка картинки заняла слишком много времени'); };
			var data = new FormData();
			data.append('action', 'upload_image'); data.append('csrf', container.dataset.blogCsrf);
			data.append('id', form.elements.id.value); data.append('editor_key', form.elements.editor_key.value);
			data.append('file', blobInfo.blob(), blobInfo.filename());
			xhr.send(data);
		});
		return state.pending;
	},
	retryImages: function() {
		var editor = window.tinymce && tinymce.get('blog-body');
		if (editor) editor.uploadImages().catch(function() {});
	},
	excerpt: function(selection) {
		var editor = window.tinymce && tinymce.get('blog-body');
		var text = editor ? (selection ? editor.selection.getContent({format: 'text'}) : editor.getContent({format: 'text'})) : document.getElementById('blog-body').value.replace(/<[^>]*>/g, ' ');
		if (selection && !text.trim()) return;
		document.getElementById('blog-excerpt').value = text.replace(/\s+/g, ' ').trim().slice(0, 400);
	},
	response: function(response) {
		return response.text().then(function(body) {
			try { return JSON.parse(body); }
			catch (err) { throw new Error('Сервер вернул некорректный ответ. Обновите страницу и повторите действие.'); }
		});
	},
	unpublish: function(button) {
		if (button.disabled) return;
		var container = button.closest('[data-blog-mid]');
		var message = document.getElementById('blog-message');
		var data = new FormData();
		data.append('action', 'unpublish');
		data.append('id', button.dataset.blogId);
		data.append('csrf', container.dataset.blogCsrf);
		button.disabled = true;
		message.textContent = 'Снимаем с публикации…';
		fetch('/ajax.php?mid=' + container.dataset.blogMid, {method: 'POST', body: data})
			.then(Blog.response).then(function(res) {
				if (!res.success) throw new Error(res.error || 'Не удалось снять статью с публикации');
				window.location.assign('/psy-cabinet/blog/?id=' + res.id);
			}).catch(function(err) {
				message.textContent = err.message || 'Ошибка сети';
				button.disabled = false;
			});
	},
	save: function(form, event) {
		var container = form.closest('[data-blog-mid]');
		var editor = window.tinymce && tinymce.get('blog-body');
		var message = document.getElementById('blog-message');
		var submit = event && event.submitter || document.activeElement;
		var status = submit && submit.dataset.blogStatus || 'draft';
		var buttons = form.querySelectorAll('button[type="submit"]');
		if (form.dataset.saving) return false;
		form.dataset.saving = '1';
		buttons.forEach(function(btn) { btn.disabled = true; });
		message.textContent = 'Сохраняем…';
		Promise.all([editor ? editor.uploadImages() : Promise.resolve([]), BlogCover.export()]).then(function(parts) {
			var results = parts[0], cover = parts[1];
			if (results && results.some(function(result) { return !result.status; })) throw new Error('Не все картинки загрузились. Повторите загрузку или удалите их из текста.');
			if (editor && Array.from(editor.getBody().querySelectorAll('img')).some(function(image) { return /^(blob:|data:)/i.test(image.getAttribute('src') || ''); })) throw new Error('Дождитесь загрузки всех картинок или удалите незагруженные изображения');
			if (editor) editor.save();
			var data = new FormData(form);
			if (cover) data.set('img_cover', cover, cover.type === 'image/webp' ? 'cover.webp' : 'cover.png');
			data.append('action', 'save');
			data.append('csrf', container.dataset.blogCsrf);
			data.append('sel_status', status);
			return fetch('/ajax.php?mid=' + container.dataset.blogMid, {method: 'POST', body: data});
		}).then(Blog.response).then(function(res) {
			if (!res.success) throw new Error(res.error || 'Ошибка сохранения');
			window.location.assign('/psy-cabinet/blog/?id=' + res.id);
		}).catch(function(err) {
			message.textContent = err.message || 'Ошибка сети';
		}).then(function() {
			delete form.dataset.saving;
			buttons.forEach(function(btn) { btn.disabled = false; });
		});
		return false;
	}
};
window.Blog = Blog;
$(document).ready(function() { Blog.init(); });
